import React from "react";
import { VictoryBar, VictoryChart, VictoryAxis, VictoryLabel } from "victory";

const BarChart = ({ data }) => {
  return (
    <div>
      <VictoryChart
        domainPadding={{ x: 30 }}
        height={300}
        padding={{ left: 0, right: 0, top: 50, bottom: 0 }}
      >
        {/* <VictoryAxis
          dependentAxis
          tickFormat={x =>
            `${Math.floor(x / 60)}:${(x % 60).toString().padStart(2, "0")}`
          }
        /> */}
        <VictoryAxis
          tickFormat={x => ""}
          style={{ tickLabels: { angle: -90 } }}
        />
        <VictoryBar
          data={data}
          x="attempt"
          y="time"
          labels={({ datum }) =>
            `${Math.floor(datum.time / 60)}:${(datum.time % 60)
              .toString()
              .padStart(2, "0")}`
          }
          style={{
            data: { fill: "#67ae8b" },
          }}
          labelComponent={<VictoryLabel dy={-20} />}
        />
      </VictoryChart>
    </div>
  );
};

export default BarChart;
